import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { UtmCapture } from '../components/UtmCapture';
import { motion } from 'framer-motion';
import { Wind, Award, ShieldCheck, Rocket, Radio, MapPin, Palmtree, Music, Coffee, Package } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WingFoilPage() {
  useEffect(() => {
    // Set meta tags for Wing Foil page
    document.title = "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Wing Foil בכנרת - לעוף מעל המים! חוף מושלם עם רוח צד, הדרכות למתחילים ומתקדמים, ציוד חדיש');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'Wing Foil בכנרת - הדור הבא של גלيشה. חוף מושלם, הדרכות מקצועיות וציוד חדיש'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'Wing Foil בכנרת - לעוף מעל המים'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-2313" data-mp="21ommp4hpr3je">
      <UtmCapture data-id="element-2314" data-mp="21nbg6wwvvhol" />
      <Navigation data-id="element-2315" data-mp="1wp092txz3la2" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-2316" data-mp="1wq1i6svfhxp5">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-2317" data-mp="248j1fqt3wqvb" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg" alt="Wing Foil Activity" className="w-full h-full object-cover" style={{
        objectPosition: '60% 38%',
        transform: 'scale(2.0)'
      }} data-id="element-2318" data-mp="24895znpalri8" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-2319" data-mp="2iz9suxqsdnxw">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-2320" data-mp="1q8i0kbcudjfu">
            Wing Foil
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-3xl mb-2 font-medium" data-id="element-2321" data-mp="36nj8fhxepfgl">
            ווינג פויל
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-2322" data-mp="3j5lvb3l7955t">
            לעוף מעל המים - הדור הבא של גלisha
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-2323" data-mp="5pe757t6ilr9">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-2324" data-mp="rw603lelatt">
          <div data-id="element-2325" data-mp="se6xdj0gd82">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-2326" data-mp="tyuukatkxwy">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-2327" data-mp="apsbaerntbk0">
              ה-Wing Foil הוא הספורט הימי החדשני ביותר שכבש את העולם. הוא משלב
              כנף (Wing) המוחזקת ביד וגלשן עם סנפיר (Foil) המאפשר ריחוף מעל
              המים. התחושה היא של שקט מוחלט ומהירות, כמעט ללא חיכוך עם המים.
              הכנרת, עם הרוחות היציבות שלה בשעות הצהריים, היא המקום המושלם ללמוד
              ולהתקדם בספורט זה.
            </p>

            {/* Perfect Spot Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cyan-50 to-teal-50 border border-cyan-100 rounded-2xl p-6 mb-8" data-id="element-2328" data-mp="pelofq9m423v">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-2329" data-mp="6jn4eb2ct4xs">
                <Wind className="w-7 h-7 text-cyan-600" data-id="element-2330" data-mp="3nwh6ypwa82f4" />
                חוף מושלם לגלישת Wing
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-2331" data-mp="39omcnaaiiczz">
                <p className="flex items-start gap-2" data-id="element-2332" data-mp="39q5rcwgisfzn">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2333" data-mp="34xcoke4m3hq7" />
                  <span data-id="element-2334" data-mp="34w1nwn6gqq3b">
                    <strong data-id="element-2335" data-mp="2zy9v7qxzuzy2">רוח צד (Side Shore)</strong> - תנאי רוח אידיאליים
                    לגלisha בטוחה
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2336" data-mp="2uxlsi80ekuo0">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2337" data-mp="3snqk4emenypj" />
                  <span data-id="element-2338" data-mp="3nondwquovmfz">
                    <strong data-id="element-2339" data-mp="3npf9i1oadk69">רוח יציבה כמעט כל יום</strong> במשך העונה
                    (אפריל-אוקטובר)
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2340" data-mp="3ir3z9pu2x7ni">
                  <MapPin className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2341" data-mp="3dp6ayh6tnmnp" />
                  <span data-id="element-2342" data-mp="27anhhpv1yexh">
                    <strong data-id="element-2343" data-mp="27ax7vek0eo3p">חניה קרובה למים</strong> - נוחות מקסימלית
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2344" data-mp="229hn7nlqujlu">
                  <Palmtree className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2345" data-mp="htifwwfi52c7" />
                  <span data-id="element-2346" data-mp="ms36s58v69nz">
                    <strong data-id="element-2347" data-mp="mrblbn8zdsbf">מדשאות</strong> לנוחות והכנת ציוד
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2348" data-mp="rqwhxr0ohokz">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2349" data-mp="rpd3m5yl1nlu" />
                  <span data-id="element-2350" data-mp="wj7jeyb2hifn">
                    <strong data-id="element-2351" data-mp="11gzn0pl2qszo">מתקן לטליית ווינגים וקומפרסור</strong>
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2352" data-mp="15ib3o5lz03vq">
                  <Music className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2353" data-mp="15h00o80cn05o" />
                  <span data-id="element-2354" data-mp="1aipflyqozxz1">
                    <strong data-id="element-2355" data-mp="1aigz7wvd2aj3">מוזיקה ופינת קפה</strong> - אווירה מושלמת
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2356" data-mp="1feo6bszhts2m">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2357" data-mp="3ca2hsg19zrre" />
                  <span data-id="element-2358" data-mp="3h7ltb86l9qfn">
                    <strong data-id="element-2359" data-mp="3h96rr8w0xtis">אחסון ציוד</strong> - ניתן לאחסן את הציוד שלכם במקום
                  </span>
                </p>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2360" data-mp="1i1gfhtnizly8">
              יתרונות ה-Wing Foil
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-2361" data-mp="1wqcobsxep2zw">
              {['ציוד קל ונייד שקל להכין לפעילות', 'בטיחותי יותר מסוגי גלישות אחרים', 'עקומת למידה מהירה יחסית', 'תחושת ריחוף ייחודית וממכרת'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-2362" data-mp="z2ueees0duub" data-mpi={i}>
                  <div className="bg-cyan-100 p-1 rounded-full" data-id="element-2363" data-mp="1dzlfcshbzem1">
                    <Rocket className="w-4 h-4 text-cyan-600" data-id="element-2364" data-mp="1e0wnt5lq1ajh" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-2365" data-mp="2pdfh04feiji8">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-2366" data-mp="2kggpzur1aso9">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-2367" data-mp="2ryeypx1e5zqf">
              <div className="flex gap-4" data-id="element-2368" data-mp="2s1j8d9xmlnoh">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2369" data-mp="2wzazi1qg55rm">
                  <ShieldCheck className="w-6 h-6 text-cyan-500" data-id="element-2370" data-mp="2iyrul3ha2fto" />
                </div>
                <div data-id="element-2371" data-mp="2n03pnoix7t99">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2372" data-mp="2mzbqk3q47de8">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2373" data-mp="3aqzdybo646br">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד גולשים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2374" data-mp="31v9ui86a5m10">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2375" data-mp="35yfvp1ejcn0m">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2376" data-mp="3tok19ebaawu9" />
                </div>
                <div data-id="element-2377" data-mp="3tmfmg1bukdf7">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2378" data-mp="29uqxp90b8zw">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2379" data-mp="2bz5r28g1sey">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2380" data-mp="2zg66q1jlta5w">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2381" data-mp="2klhwka39dnjy">
                  <Award className="w-6 h-6 text-cyan-500" data-id="element-2382" data-mp="2pk2t9zjaxp3n" />
                </div>
                <div data-id="element-2383" data-mp="2pm5ttdi2z0mm">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2384" data-mp="2bsy2lmxww75g">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2385" data-mp="2bqld8optquid">
                    הצטרפו לקהילת גולשים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2386" data-mp="21sdx283d0ghf">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2387" data-mp="26t1yzot4mhqf">
                  <Radio className="w-6 h-6 text-cyan-500" data-id="element-2388" data-mp="1stsh8kp9vfkc" />
                </div>
                <div data-id="element-2389" data-mp="1svwuvucz3sxt">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2390" data-mp="1wvdz6kgnyk1e">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2391" data-mp="1e6bpni0mtmsf">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2392" data-mp="1n8l0ya3q5k6v">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2393" data-mp="1i8ou833n7enm">
                  <Package className="w-6 h-6 text-cyan-500" data-id="element-2394" data-mp="1iat6p9flxlzi" />
                </div>
                <div data-id="element-2395" data-mp="1x4ek4cby8bxm">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2396" data-mp="1x3v2kwq7npk4">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2397" data-mp="1s6cypkr1w0iz">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2398" data-mp="21x7o2xzlfg8n">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2399" data-mp="2fwgtr3q6aryd">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2400" data-mp="2fucqmo03lwz5" />
                </div>
                <div data-id="element-2401" data-mp="2ayxfw4xe0h6y">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2402" data-mp="2av9md5rxzus8">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2403" data-mp="1cl9xjve6993s">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-2404" data-mp="1mdfpx68c5sji">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-2405" data-mp="1r9ebkm2a4wg8">
                רוצה להתחיל לעוף!
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Campaign Banner */}
      <section className="py-16 bg-gradient-to-r from-cyan-600 to-blue-600 text-white text-center" data-id="element-2406" data-mp="5ynwcpzgef8m">
        <div className="container mx-auto px-4" data-id="element-2407" data-mp="awpqc5yf3yyv">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2408" data-mp="3ceu7azj9pc9">
            מבצע מיוחד למצטרפים חדשים!
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-2409" data-mp="3ur2p2xpf1z8y">
            השאירו פרטים בדף הקמפיין שלנו וקבלו הצעה מיוחדת לשיעור היכרות
          </p>
          <a href="/wingfoil-campaign" className="inline-block bg-white text-cyan-600 font-bold text-lg py-4 px-10 rounded-full hover:bg-cyan-50 transition-colors shadow-lg hover:scale-105" data-id="element-2410" data-mp="3psj1ytz36hf0">
            למעבר לדף המבצע והשארת פרטים ←
          </a>
        </div>
      </section>

      <ContactSection data-id="element-2411" data-mp="had5g7ik55nj" />
      <Footer data-id="element-2412" data-mp="cdd2i5h08j0n" />
    </div>;
}